import React from 'react'

const EventFinderComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default EventFinderComponent
